import DeleteIcon from '@mui/icons-material/Delete';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { DEVICE_TYPE } from '../../config/devices';
import actions, { selectors as devicesSelectors } from '../../modules/devices';
import { getDeleteDeviceContext } from '../../modules/devices/helpers/deleteDeviceHelpers';
import ButtonDanger from '../ButtonDanger';
import Modal from '../Modal';
import messages from './messages';

const styles = {
  deleteButton: {
    '&:hover': {
      color: 'secondary.main',
    },
    color: 'action.disabled',
  },
  list: {
    typography: 'body1',
  },
  text: {
    mb: 1.5,
  },
};

function DeleteDeviceModal() {
  const location = useLocation();
  const context = getDeleteDeviceContext(location);
  const deviceType = useSelector(devicesSelectors.getDeleteModalDeviceType);
  const deviceId = useSelector(devicesSelectors.getDeleteModalDeviceId);
  const open = useSelector(devicesSelectors.getDeleteModalShow);
  const processing = useSelector(devicesSelectors.getDeleteModalProcessing);
  const dispatch = useDispatch();

  if (!open) return <>{false}</>;

  return (
    <Modal
      actions={
        <>
          <Button onClick={() => dispatch(actions.deleteDeviceModalHide())}>
            <FormattedMessage {...messages.deleteDeviceCancelButton} />
          </Button>
          <ButtonDanger
            disabled={processing}
            onClick={() => dispatch(actions.deleteDevice(deviceId, context))}
            startIcon={<DeleteIcon />}
          >
            <FormattedMessage {...messages.deleteDeviceConfirmButton} />
          </ButtonDanger>
        </>
      }
      headerVariant="danger"
      maxWidth="sm"
      name="delete-device"
      onClose={() => dispatch(actions.deleteDeviceModalHide())}
      open
      title={<FormattedMessage {...messages.deleteDeviceTitle} />}
      canClose={true}
    >
      {deviceType == DEVICE_TYPE.DORMAKABA_ELECTRONIC_LOCK ? (
        <Box>
          <Typography sx={styles.text}>
            <FormattedMessage {...messages.deleteDeviceDormakabaText} />
          </Typography>
        </Box>
      ) : (
        <Box>
          <Typography sx={styles.text}>
            <FormattedMessage {...messages.deleteDeviceTextRow1} />
          </Typography>
          <Typography sx={styles.text}>
            <FormattedMessage {...messages.deleteDeviceTextRow2} />
          </Typography>
          <Box component="ul" sx={styles.list}>
            <Typography {...messages.deleteDeviceTextList1} component={FormattedMessage} tagName="li" />
            <Typography {...messages.deleteDeviceTextList2} component={FormattedMessage} tagName="li" />
            <Typography {...messages.deleteDeviceTextList3} component={FormattedMessage} tagName="li" />
          </Box>
          <Typography sx={styles.text}>
            <FormattedMessage {...messages.deleteDeviceTextRow3} />
          </Typography>
        </Box>
      )}
    </Modal>
  );
}

export default DeleteDeviceModal;
